import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const CircleBluetoothFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M12 20.74C7.18 20.74 3.18 16.76 3.18 11.96C3.18 7.16 7.18 3.18 12 3.18C16.82 3.18 20.82 7.16 20.82 11.96C20.82 16.76 16.82 20.74 12 20.74ZM10.64 12.02L8.26 14.02L9.12 14.98L12.38 12.24V16.4L15.48 14.14L12.6 12.02L15.48 9.9L12.38 7.64V11.8L9.12 9.06L8.26 10.02L10.64 12.02Z" />
    </SvgIcon>
  );
});
